import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

const C = {
  bg:"#0a0a0f", surface:"rgba(255,255,255,0.04)", sh:"rgba(255,255,255,0.07)",
  border:"rgba(255,255,255,0.08)", text:"#f5f5f7",
  sec:"rgba(245,245,247,0.55)", ter:"rgba(245,245,247,0.30)",
  accent:"#0a84ff", green:"#30d158", orange:"#ff9f0a", red:"#ff453a",
};
const F = "-apple-system,'SF Pro Display','Helvetica Neue',sans-serif";

const StatPill = ({ label, value, color=C.text }) => (
  <div style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${C.border}`, borderRadius:12, padding:"0.75rem 1rem" }}>
    <p style={{ margin:"0 0 0.2rem", fontSize:"0.62rem", color:C.sec, fontWeight:500 }}>{label}</p>
    <p style={{ margin:0, fontSize:"1.2rem", fontWeight:700, color, letterSpacing:"-0.5px", fontVariantNumeric:"tabular-nums", lineHeight:1 }}>{value}</p>
  </div>
);

export default function ReportAdmin() {
  const [reportData, setReportData] = useState([]);
  const [periodo, setPeriodo] = useState("oggi");
  const [gestoreSelezionato, setGestoreSelezionato] = useState(null);
  const [dettagliPiatti, setDettagliPiatti] = useState([]);
  const [andamentoOrdini, setAndamentoOrdini] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [permError, setPermError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(u => { if (!u) navigate("/login"); });
    return () => unsub();
  }, [navigate]);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true); setPermError("");
      let ordini = [], localiMap = {};
      try { const s = await getDocs(collection(db,"ordini")); ordini = s.docs.map(d=>({id:d.id,...d.data()})); }
      catch (e) { setPermError("Permessi insufficienti per leggere gli ordini."); setLoading(false); return; }
      try { const s = await getDocs(collection(db,"locali")); s.docs.forEach(d=>{ localiMap[d.id]=d.data().nome||d.id; }); }
      catch {}

      const now=new Date();
      const ig=new Date(now.getFullYear(),now.getMonth(),now.getDate());
      const is=new Date(now); is.setDate(now.getDate()-now.getDay()); is.setHours(0,0,0,0);
      const im=new Date(now.getFullYear(),now.getMonth(),1);

      const filtrati=ordini.filter(o=>{
        if (o.stato!=="pagamento"&&o.stato!=="archiviato") return false;
        const ts=o.timestamp?.toDate?o.timestamp.toDate():new Date(0);
        if (periodo==="oggi") return ts>=ig;
        if (periodo==="settimana") return ts>=is;
        if (periodo==="mese") return ts>=im;
        return true;
      });

      const byLocale={};
      for (const o of filtrati) {
        const lt=o.locale||"Sconosciuto";
        if (!byLocale[lt]) byLocale[lt]={locale:lt,nomeLocale:localiMap[lt]||lt,totaleOrdini:0,totaleIncasso:0,totaleCoperti:0,ordini:[]};
        byLocale[lt].totaleOrdini++;
        byLocale[lt].totaleIncasso+=o.totale||0;
        byLocale[lt].totaleCoperti+=o.coperti||0;
        byLocale[lt].ordini.push(o);
      }

      setReportData(Object.values(byLocale).map(d=>({
        gestore:d.nomeLocale, locali:[d.locale],
        totaleOrdini:d.totaleOrdini,
        totaleIncasso:Math.round(d.totaleIncasso*100)/100,
        scontrinoMedio:Math.round((d.totaleIncasso/d.totaleOrdini)*100)/100,
        totaleCoperti:d.totaleCoperti, ordini:d.ordini
      })));
      setLoading(false);
    };
    fetch();
  }, [periodo]);

  const caricaDettagli = (data, tipo) => {
    setGestoreSelezionato(data.gestore); setModalType(tipo);
    if (tipo==="piatti") {
      const cnt={};
      data.ordini.forEach(o=>(o.items||[]).forEach(item=>{ const n=item.name||"?"; cnt[n]=(cnt[n]||0)+(item.quantity||0); }));
      setDettagliPiatti(Object.entries(cnt).map(([nome,quantita])=>({nome,quantita})).sort((a,b)=>b.quantita-a.quantita));
    } else {
      const rpd={};
      data.ordini.forEach(o=>{
        const ts=o.timestamp?.toDate?o.timestamp.toDate():new Date(0);
        const k=periodo==="oggi"?ts.getHours()+":00":ts.toLocaleDateString("it-IT",{day:"2-digit",month:"2-digit"});
        if (!rpd[k]) rpd[k]={ordini:0,incasso:0};
        rpd[k].ordini++; rpd[k].incasso+=o.totale||0;
      });
      setAndamentoOrdini(Object.entries(rpd).map(([p,d])=>({periodo:p,ordini:d.ordini,incasso:Math.round(d.incasso*100)/100})).sort((a,b)=>a.periodo.localeCompare(b.periodo)));
    }
  };

  const chiudi = () => { setGestoreSelezionato(null); setDettagliPiatti([]); setAndamentoOrdini([]); setModalType(null); };

  const PERIODI = [["oggi","Oggi"],["settimana","Settimana"],["mese","Mese"],["tutto","Tutto"]];

  return (
    <>
      <Navbar />
      <div style={{ minHeight:"100vh", background:C.bg, fontFamily:F, color:C.text }}>
        <div className="page-with-navbar" style={{ maxWidth:960, margin:"0 auto" }}>

          {/* Header */}
          <div style={{ marginBottom:"1.75rem" }}>
            <p style={{ margin:"0 0 0.25rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Amministrazione</p>
            <h1 style={{ margin:0, fontSize:"clamp(1.4rem,3vw,1.9rem)", fontWeight:700, letterSpacing:"-0.5px" }}>Report Admin</h1>
            <p style={{ margin:"0.3rem 0 0", fontSize:"0.8rem", color:C.ter }}>Statistiche aggregate per locale</p>
          </div>

          {/* Period filter */}
          <div style={{ display:"flex", gap:"0.5rem", flexWrap:"wrap", marginBottom:"1.5rem" }}>
            {PERIODI.map(([val,lbl])=>(
              <button key={val} onClick={()=>setPeriodo(val)} style={{ padding:"0.5rem 1.1rem", background: periodo===val?C.accent:"rgba(255,255,255,0.05)", border:`1px solid ${periodo===val?C.accent:"rgba(255,255,255,0.09)"}`, borderRadius:999, color: periodo===val?"#fff":C.sec, fontSize:"0.8rem", fontWeight: periodo===val?600:500, cursor:"pointer", fontFamily:F, transition:"all 150ms ease" }}>
                {lbl}
              </button>
            ))}
          </div>

          {permError && (
            <div style={{ padding:"0.85rem 1rem", background:"rgba(255,69,58,0.1)", border:"1px solid rgba(255,69,58,0.25)", borderRadius:12, marginBottom:"1.25rem", fontSize:"0.8rem", color:C.red, lineHeight:1.6 }}>
              <strong>Errore permessi:</strong> {permError}
            </div>
          )}

          {loading ? (
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:"1rem", padding:"4rem 0" }}>
              <div style={{ width:32, height:32, border:`2px solid ${C.border}`, borderTop:`2px solid ${C.sec}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} />
              <p style={{ margin:0, color:C.sec, fontSize:"0.82rem" }}>Caricamento dati…</p>
              <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            </div>
          ) : reportData.length===0 ? (
            <p style={{ color:C.ter, textAlign:"center", padding:"3rem 0" }}>Nessun dato per il periodo selezionato.</p>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:"0.85rem" }}>
              {reportData.map((data,idx)=>(
                <div key={idx} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, overflow:"hidden" }}>
                  <div style={{ padding:"1rem 1.25rem", borderBottom:`1px solid ${C.border}` }}>
                    <p style={{ margin:"0 0 0.15rem", fontSize:"1rem", fontWeight:700 }}>{data.gestore}</p>
                    <p style={{ margin:0, fontSize:"0.7rem", color:C.ter }}>{data.locali.join(", ")}</p>
                  </div>
                  <div style={{ padding:"1rem 1.25rem" }}>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))", gap:"0.6rem", marginBottom:"1rem" }}>
                      <StatPill label="Ordini totali"   value={data.totaleOrdini} color={C.accent} />
                      <StatPill label="Incasso totale"  value={`€${data.totaleIncasso.toFixed(2)}`} color={C.green} />
                      <StatPill label="Scontrino medio" value={`€${(data.scontrinoMedio||0).toFixed(2)}`} color={C.orange} />
                      <StatPill label="Coperti totali"  value={data.totaleCoperti} />
                    </div>
                    <div style={{ display:"flex", gap:"0.5rem", flexWrap:"wrap" }}>
                      <button onClick={()=>caricaDettagli(data,"piatti")} style={{ padding:"0.55rem 1rem", background:"rgba(10,132,255,0.12)", border:"1px solid rgba(10,132,255,0.25)", borderRadius:10, color:C.accent, fontSize:"0.78rem", fontWeight:600, cursor:"pointer", fontFamily:F }}>
                        Piatti più venduti
                      </button>
                      <button onClick={()=>caricaDettagli(data,"andamento")} style={{ padding:"0.55rem 1rem", background:"rgba(48,209,88,0.1)", border:"1px solid rgba(48,209,88,0.22)", borderRadius:10, color:C.green, fontSize:"0.78rem", fontWeight:600, cursor:"pointer", fontFamily:F }}>
                        Andamento ordini
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {gestoreSelezionato && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.72)", backdropFilter:"blur(10px)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000001, padding:"1rem" }} onClick={chiudi}>
          <div style={{ background:"#1c1c1e", border:`1px solid ${C.border}`, borderRadius:22, padding:"1.5rem 1.6rem", maxWidth:640, width:"100%", maxHeight:"82vh", overflowY:"auto", boxShadow:"0 24px 64px rgba(0,0,0,0.65)" }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"1.25rem" }}>
              <h3 style={{ margin:0, fontSize:"0.95rem", fontWeight:700 }}>
                {modalType==="piatti" ? "Piatti più venduti" : "Andamento ordini"} — {gestoreSelezionato}
              </h3>
              <button onClick={chiudi} style={{ background:`rgba(255,255,255,0.06)`, border:"none", borderRadius:"50%", width:30, height:30, color:C.sec, cursor:"pointer", fontSize:"1rem", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:F }}>✕</button>
            </div>

            {modalType==="piatti" && (
              dettagliPiatti.length===0 ? <p style={{ color:C.ter }}>Nessun piatto venduto.</p> : (
                <div style={{ display:"flex", flexDirection:"column", gap:"0.4rem" }}>
                  {dettagliPiatti.map((p,i)=>(
                    <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"0.6rem 0.8rem", background:"rgba(255,255,255,0.04)", borderRadius:10 }}>
                      <span style={{ fontSize:"0.82rem", color:C.text }}>{p.nome}</span>
                      <span style={{ fontSize:"0.82rem", fontWeight:700, color:C.accent }}>{p.quantita}</span>
                    </div>
                  ))}
                </div>
              )
            )}

            {modalType==="andamento" && (
              andamentoOrdini.length===0 ? <p style={{ color:C.ter }}>Nessun dato disponibile.</p> : (
                <div style={{ display:"flex", flexDirection:"column", gap:"0.85rem" }}>
                  {andamentoOrdini.map((item,i)=>{
                    const maxO=Math.max(...andamentoOrdini.map(x=>x.ordini));
                    const pct=(item.ordini/maxO)*100;
                    return (
                      <div key={i}>
                        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:"0.35rem" }}>
                          <span style={{ fontSize:"0.78rem", fontWeight:600, color:C.text }}>{item.periodo}</span>
                          <span style={{ fontSize:"0.75rem", color:C.sec }}>{item.ordini} ordini · €{item.incasso.toFixed(2)}</span>
                        </div>
                        <div style={{ height:6, background:"rgba(255,255,255,0.08)", borderRadius:99, overflow:"hidden" }}>
                          <div style={{ width:`${pct}%`, height:"100%", background:C.green, borderRadius:99, transition:"width 0.3s ease" }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            )}
          </div>
        </div>
      )}
    </>
  );
}
